// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Yj7y","label":"Radio_label__1FA1Q","checkMark":"Radio_checkMark__2mBjf","disabled":"Radio_disabled__r73tz"};